import { render } from "./PosSalesListPage.vue?vue&type=template&id=09a10634&scoped=true&ts=true"
import script from "./PosSalesListPage.vue?vue&type=script&lang=ts"
export * from "./PosSalesListPage.vue?vue&type=script&lang=ts"

import "./PosSalesListPage.vue?vue&type=style&index=0&id=09a10634&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a10634"]])

export default __exports__